;(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param    {String}    type    The type of adjustment.
   * @param    {Number}    value    The number.
   * @param    {Integer}    exp        The exponent (the 10 logarithm of the adjustment base).
   * @returns    {Number}            The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value)
    }
    value = +value
    exp = +exp
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN
    }
    // Shift
    value = value.toString().split('e')
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)))
    // Shift back
    value = value.toString().split('e')
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp))
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp)
    }
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp)
    }
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp)
    }
  }

  // `Number.isInteger` NÃO é redefinido aqui, de propósito.
  //
  // Havia um override que ignorava o argumento e lia `this` — que numa chamada
  // `Number.isInteger(75)` é o próprio construtor `Number`. Resultado medido:
  // devolvia `false` para QUALQUER entrada, inclusive inteiros, e valia no
  // bundle de produção (`main.js:39` importa este arquivo).
  //
  // O sintoma que o denunciou: uma nota 8,75 renderizada como "8,8", e o rótulo
  // de velocidade do áudio em `chat-media-preview.vue:109` saindo "1.0x" em vez
  // de "1x" — o consumidor esperava o comportamento nativo e recebia o oposto.
  //
  // O nativo existe desde o ES6 e o projeto roda Node 18: não há o que
  // polyfillar. Se algum dia faltar, use `Number.isInteger = (v) => typeof v
  // === 'number' && isFinite(v) && Math.floor(v) === v` — com ARGUMENTO.

  // Decimal length count
  Number.decimalLength = function(v) {
    if (typeof v !== 'number') {
      // TODO: Usar getNumber
      return 0
    }
    if (Math.floor(v) === v) return 0
    return v.toString().split('.')[1].length || 0
  }
})()
